import { Action, ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { LoadingStatus, LoadingType } from './types';

interface RequestActions {
  loading: LoadingStatus;
  env: string;
}

const initialState: RequestActions = {
  loading: {},
  env: 'local',
};

const typePrefixRegex = /^(.*)\//;

const setLoadingState = (state: RequestActions, action: Action, loadingType: LoadingType) => {
  const typePrefix = action.type.match(typePrefixRegex)?.[1];
  if (typePrefix) {
    state.loading[typePrefix] = loadingType;
  }
};

const appSlice = createSlice({
  name: 'requestStatus',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<RequestActions>) => {
    builder.addMatcher(
      (action) => action.type.endsWith('/pending'),
      (state, action) => setLoadingState(state, action, 'pending'),
    );

    builder.addMatcher(
      (action) => action.type.endsWith('/fulfilled'),
      (state, action) => setLoadingState(state, action, 'idle'),
    );

    builder.addMatcher(
      (action) => action.type.endsWith('/rejected'),
      (state, action) => setLoadingState(state, action, 'idle'),
    );
  },
});

const { reducer } = appSlice;

export default reducer;
